import { AutoTableContext } from "./auto-table-provider.contants";
import { IProps } from "./auto-table-provider.types";

/**
 * AutoTableProvider component to provide context for AutoTable.
 * @param rowExpansion - Row expansion configuration
 * @param highlightedRowsKeys - Keys of highlighted rows
 * @param getRowKey - Function to get the key of a row
 * @param children - Child components
 * @returns Provider component
 */
const AutoTableProvider = <T,>({ rowExpansion, highlightedRowsKeys, getRowKey, getRowLink, children }: IProps<T>) => {
    return (
        <AutoTableContext.Provider value={{ rowExpansion, highlightedRowsKeys, getRowKey, getRowLink }}>
            {children}
        </AutoTableContext.Provider>
    );
};

export { AutoTableProvider };
